<template>
<d-container fluid>
  <!-- Small Stats Blocks -->
  <d-row>
    <d-col lg v-for="(stats, idx) in smallStats" :key="idx" class="mb-4">
      <small-stats :id="`small-stats-${idx}`" variation="1" :chart-data="stats.datasets" :label="stats.label" :value="stats.value" :percentage="stats.percentage" :increase="stats.increase" :decrease="stats.decrease" />
    </d-col>
  </d-row>
  <d-row>
    <!-- Ticket -->
    <d-col lg="12" xl="9" sm="12" class="mb-4">
      <d-card class="card-small">

        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <h6 class="m-0">Lista dos Chamados</h6>
          <div class="block-handle"></div>
        </d-card-header>

        <d-card-body class="table-overflow">
          <ticket-table :tickets="tickets.list" />
        </d-card-body>
      </d-card>
    </d-col>
     <!-- Tickets Stats (lite) -->
    <d-col lg="5" xl="3" sm="12" class="mb-4">
      <tickets-stats :chart-data="chartData" v-if="chartData" title="Visão geral de chamados do mês"/>
    </d-col>
  </d-row>

  <d-row>
    <!-- Projects Overview -->
    <!-- <d-col lg="8" md="6" sm="12" class="mb-4">
      <bo-users-overview />
    </d-col> -->
  </d-row>
</d-container>
</template>

<script>
import { mapActions } from 'vuex';
import SmallStats from '_common/components/dashboard/SmallStats.vue';
import DoughnutStats from '_common/components/dashboard/DoughnutStats.vue';
import TicketTable from '_modules/ticket/components/TicketListTable.vue';
import TicketsStats from '_common/components/dashboard/TicketsStats.vue';
import DashboardService from '_services/rest/modules/dashboard';

export default {
  name: 'dashboard-admin',
  components: {
    SmallStats,
    TicketTable,
    TicketsStats,
    DoughnutStats,
  },
  computed: {
    tickets() {
      const { ticketList } = this.$store.state.ticket;
      if (ticketList && ticketList.list.length) {
        return ticketList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  data() {
    return {
      smallStats: null,
      chartData: null,
      pagination: {
        skip: 0,
        take: 10,
        page: 1,
      },
    };
  },
  methods: {
    ...mapActions([
      'getTicketList',
    ]),
    getList() {
      this.getTicketList(this.pagination);
    },
    getQuotationsStats() {
      DashboardService.getStatsDashboard()
        .then(response => {
          this.smallStats = response;
        });
    },
    getTicketsStats() {
      DashboardService.getTicketsStats()
        .then(response => {
          this.chartData = response;
        });
    },
  },
  beforeCreate() {},
  mounted() {
    this.getList();
    this.getTicketsStats();
    this.getQuotationsStats();
  },
};
</script>

<style lang="scss" scoped>
.drives {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .card {
    display: flex;
    justify-content: center;
    min-width: 280px;
    max-width: 280px;
}
}
</style>
